import { render, staticRenderFns } from "./navcon.vue?vue&type=template&id=66b23b46&scoped=true&"
import script from "./navcon.vue?vue&type=script&lang=js&"
export * from "./navcon.vue?vue&type=script&lang=js&"
import style0 from "./navcon.vue?vue&type=style&index=0&id=66b23b46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b23b46",
  null
  
)

export default component.exports